// extracted by mini-css-extract-plugin
export var glassdoorReviewsArrowLeft = "bL_hg";
export var glassdoorReviewsArrowRight = "bL_hh";
export var glassdoorReviewsContainer = "bL_g9";
export var glassdoorReviewsDots = "bL_hf";
export var glassdoorReviewsItem = "bL_hb";
export var glassdoorReviewsItemFooter = "bL_hd";
export var glassdoorReviewsItemHeaderStars = "bL_hc";